import React from 'react'
import Header from '../Components/Header';
import About from '../Components/About';
import Footer from '../Components/Footer';
import Showact from '../Components/Showact';
import Latestproduct from '../Components/Latestproduct';
import slide01 from '../assests/img/home-banner-01.jpg';
import slide02 from '../assests/img/home-banner-02.jpg';
import slide03 from '../assests/img/home-banner-03.jpg';


import img01 from '../assests/img/img-001.jpg';
import img02 from '../assests/img/img-002.jpg';
import img03 from '../assests/img/img-003.jpg';
import img04 from '../assests/img/img-004.jpg';
import img05 from '../assests/img/img-005.jpg';
import img06 from '../assests/img/img-006.jpg';




import { Helmet } from "react-helmet-async";


import Slider from "react-slick";


function App() {
   
  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

return (
    <div >
     <Helmet>
       <title>The Picture Valley | Exclusive Backdrops Outdooe & Inndoor Photography & Cinematography Location AGRA</title>
        <meta
          name="description"
          content="Exclusive Backdrops Outdooe & Inndoor Photography & Cinematography Location AGRA"
        />
        <meta
          name="keywords"
          content="Exclusive Backdrops Outdooe & Inndoor Photography & Cinematography Location AGRA"
        />
      </Helmet>

      <Header />
      {/* <Showlist/> */}

      <div className='container-new main-slider-container'>

      

<div className='main-slider'>
      <Slider {...settings}>
      <div>
       <img src={slide01}/>
      </div>
      <div>
       <img src={slide02}/>
      </div>
       <div>
       <img src={slide03}/>
      </div>
    </Slider>
</div>
      </div>

     

     


<About/>
<Showact/>
<Latestproduct/>
<Footer/>
 </div>
)

}

export default App;
